import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, Serialize } from 'cerialize';
import { DayOfWeekHours } from './day-of-week-hours';

export class CollectionSiteHours {
  @autoserialize
  truckAccess: boolean;

  @autoserialize
  twentyFourHours: boolean;

  @autoserializeAs(Date)
  normalOpen: Date;

  @autoserializeAs(Date)
  normalClose: Date;

  @autoserialize
  daysOfWeek: Array<DayOfWeekHours>;

  /**** Serialization ****/

  static OnSerialized(instance: CollectionSiteHours, json: any): void {
    if (!isNullOrUndefined(instance.normalOpen)) {
      json.normalOpen = DateUtil.serializeLocalTime(instance.normalOpen);
    }
    if (!isNullOrUndefined(instance.normalClose)) {
      json.normalClose = DateUtil.serializeLocalTime(instance.normalClose);
    }
  }

  static OnDeserialized(instance: CollectionSiteHours, json: any): void {
    if (!isNullOrUndefined(json['normalOpen'])) {
      instance.normalOpen = DateUtil.deserializeLocalTime(json['normalOpen']);
    }

    if (!isNullOrUndefined(json['normalClose'])) {
      instance.normalClose = DateUtil.deserializeLocalTime(json['normalClose']);
    }
  }
}
